import { type Contact } from 'entities/Contacts/model/Contact'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type Conversation } from 'entities/Conversation'

type IIsOptOutCurrentInboxProps = {
  conversation?: Conversation
  contact?: Contact
  entities: IEntitiesStore
}

export const isOptOutCurrentInbox = ({
  conversation,
  contact,
  entities,
}: IIsOptOutCurrentInboxProps) => {
  let inbox = entities.inboxesStore.getItem(conversation?.inbox_id)
  if (conversation?.isNew) {
    inbox = entities.inboxesStore.currentInbox
  }
  const number =
    inbox?.type === 'inbox' ? entities.numbersStore.getItem(inbox?.numberId) : undefined

  if (!contact?.optInShortCode.length) return false
  if (!number?.isShortCode) return false

  const numberId = number.id

  const optInShortCode = contact.optInShortCode.find((item) => item.number_id === numberId)

  if (!optInShortCode) return false

  return !optInShortCode.value
}
